import Procedures from './Procedures';

export default Procedures;
